<template>
  <div>
    <PromotionsPage />
  </div>
</template>

<script>
import PromotionsPage from '../components/PromotionsPage';

export default {
  name: 'PlatformPromotions',
  components: {
    PromotionsPage,
  },
};
</script>
